export const partners = [
  {
    id: 'esa',
    image: 'images/brands/esa-logo-outline.webp',
    alt: 'European Space Agency',
    href: '/contact-us-solution',
  },
  {
    id: 'uksa',
    image: 'images/brands/uksa-logo-outline.webp',
    alt: 'UK Space Agency',
    href: '/contact-us-solution',
  },
  {
    id: 'catapult',
    image: 'images/brands/catapult-logo-outline.webp',
    alt: 'Satellite Applications Catapult',
    href: '/contact-us-solution',
  },
  {
    id: 'innovate-uk',
    image: 'images/brands/innovate-uk-logo-white.webp',
    alt: 'Innovate UK',
    href: '/contact-us-solution',
  },
];

const features = [
  {
    id: 'map',
    title: 'Build traceability',
    description: 'Farm-level. Every lot linked.',
    href: '/farm-maps',
    image: 'images/blog/blogfield.webp',
  },
  {
    id: 'manage',
    title: 'Plan procurement',
    description: 'Forecasts per farm and zone.',
    href: '/supply-risk',
    image: 'images/landing/banner-cover-1.webp',
  },
  {
    id: 'optimise',
    title: 'Prove impact',
    description: 'Verified. Measurable. Auditable.',
    href: '/farm-health-scores',
    image: 'images/landing/banner-cover-b.webp',
  },
];

export default features;
